export default "__VITE_ASSET__ca58b6b8__"